import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { AuthGuardService } from './user/auth-guard.service/auth-guard.service.component';
// Import Containers
import { DefaultLayoutComponent } from './containers';
//import { P404Component } from './template-samples/error/404.component';
//import { P500Component } from './template-samples/error/500.component';
import { LoginComponent } from '../app/public/login/login.component';
//import { RegisterComponent } from './template-samples/register/register.component';

import { SecureGuardService } from './shared/security/secure-guard.service';
import { Login } from '../app/public/login/login';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: UserComponent,
    children: [{ path: '', component: SignInComponent}]
  },
  {
    path: 'register', canActivate: [AuthGuardService],
    component: UserComponent,
    children: [{ path: '', component: SignUpComponent}]
  },
  // {
  //   path: '404',
  //   component: P404Component,
  //   data: {
  //     title: 'Page 404'
  //   }
  // },
  // {
  //   path: '500',
  //   component: P500Component,
  //   data: {
  //     title: 'Page 500'
  //   }
  // },
  // {
  //   path: 'login',
  //   component: LoginComponent,
  //   data: {
  //     title: 'Login Page'
  //   }
  // },
  // {
  //   path: 'register',
  //   component: RegisterComponent,
  //   data: {
  //     title: 'Register Page'
  //   }
  // },
  {
    path: '', canActivate: [AuthGuardService],
    component: DefaultLayoutComponent,
    //canActivate: [SecureGuardService],
    data: {
      title: 'Home'
    },
    children: [
      // #region Main Routing Modules //
  
      {
        path: 'services',
        loadChildren: () => import('./views/service/service.module').then(m => m.ServiceModule)
      },

      {
        path: 'members',
        loadChildren: () => import('./views/member/member.module').then(m => m.MemberModule)
      },
      {
        path: 'courses',
        loadChildren: () => import('./views/course/course.module').then(m => m.CourseModule)
      },

      {
        path: 'articles',
        loadChildren: () => import('./views/article/article.module').then(m => m.ArticleModule)
      },
      {
        path: 'events',
        loadChildren: () => import('./views/event/event.module').then(m => m.EventModule)
      },
      {
        path: 'videos',
        loadChildren: () => import('./views/video/video.module').then(m => m.VideoModule)
      },
      {
        path: 'faqs',
        loadChildren: () => import('./views/FAQ/faq.module').then(m => m.FaqModule)
      },
      {
        path: 'stories',
        loadChildren: () => import('./views/story/story.module').then(m => m.StoryModule)
      }
      // #end region //

      , {
        path: 'base',
        loadChildren: () => import('./template-samples/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./template-samples/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./template-samples/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },

      {
        path: 'icons',
        loadChildren: () => import('./template-samples/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./template-samples/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./template-samples/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./template-samples/widgets/widgets.module').then(m => m.WidgetsModule)
      }
    ]
  },
  { path: '**', component: UserComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
